
import { Component, Vue } from "vue-property-decorator";
import PModal from "@/components/look/PModal.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VueMethods from "@/vue-methods";
import PFormInputFile from "@/components/common/PFormInputFile.vue";

@Component({
  name: "add-massive-service-point-modal",
  components: { PFormInputFile, PModal, ValidationObserver, ValidationProvider },
  mixins: [VueMethods],
})
export default class AddMassiveServicePointModal extends Vue {
  file: File | null = null;
  isLoadingImport = false;
  isLoadingTemplate = false;

  constructor() {
    super();
  }

  initData(): void {
    this.file = null;
    this.isLoadingImport = false;
    this.isLoadingTemplate = false;
    const fileInput = this.$refs.fileInput as InstanceType<typeof PFormInputFile> | undefined;
    fileInput?.reset();
  }

  close(): void {
    this.$emit("close");
  }

  async importServicePoints(): Promise<void> {
    const fileInput = this.$refs.fileInput as InstanceType<typeof PFormInputFile> | undefined;
    const observer = fileInput?.$refs.observer as
      | InstanceType<typeof ValidationObserver>
      | undefined;
    const isValid = await observer?.validate();

    if (!isValid || !this.file) {
      return;
    }

    this.isLoadingImport = true;
    try {
      const res = await this.$services.fileImport.addMassiveFileImportServicepoint(this.file);
      if (res) {
        this.$emit("import-success", res);
      }
    } finally {
      this.isLoadingImport = false;
    }
  }

  async downloadTemplate(): Promise<void> {
    this.isLoadingTemplate = true;
    try {
      const res = await this.$services.fileImport.getTemplateFileImportServicepoint();
      if (res) {
        this.downloadFile(res);
      }
    } finally {
      this.isLoadingTemplate = false;
    }
  }

  get extensionPermitted(): string[] {
    return ["XLSX"];
  }

  get extensionPermittedAsMessage(): string {
    return this.$t("label.validation.file.extensionpermitted", [
      this.extensionPermitted.join(", "),
    ]) as string;
  }
}
